/**
 * Feature Flags Configuration
 * 
 * Use these flags to enable/disable features across the application.
 */

export const featureFlags = {
  /**
   * When enabled, the site displays only the "Be Right Back" page.
   * All other pages become inaccessible and navigation is hidden.
   * 
   * Set to `true` when the business is temporarily closed.
   * Set to `false` to restore normal site operation.
   */
  beRightBackMode: true,
};

export default featureFlags;
